<ng-container *transloco="let t">
  <div class="orthopedic-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('orthopedic.finding') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="finding" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('orthopedic.opinion') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="opinion" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('orthopedic.recommendation') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="recommendation" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('orthopedic.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="note" rows="3"></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
